<template>
  <div class="main">
    <Result
      :icon="
        getIcon(
          error
            ? 'img/credit-line/error_warning_icon.svg'
            : 'img/credit-line/success_cc.svg'
        )
      "
      :error="error"
      :title="title"
      :show-device-tag="error"
      :description="description"
      :btnText="btnText"
      :custom-footer="error"
      @dismissFunc="dismiss()"
    >
      <div class="bottom-0 mb-5 position-absolute w-100 px-3">
        <p
          id="contact-support"
          class="fst-italic text-decoration-none text-center w-100 mx-auto mb-3"
          @click="openWhatsApp"
        >
          {{ t("PAYJOY_CARD_VIEWS.CALL_SUPPORT") }}
        </p>

        <Button id="btn-continue" class="text-start p-3" @click="dismiss()">
          <p class="text-center text-white fw-bold my-auto">
            {{ btnText }}
          </p>
        </Button>
      </div>
    </Result>

    <iframe
      class="embed-responsive-item w-100"
      id="iframe"
      :src="IFrameUrl"
    ></iframe>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import Result from "@/apps/credit-line/components/Result.vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { useRouter } from "vue-router";
import Button from "@/apps/credit-line/components/Button.vue";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
export default defineComponent({
  name: "CreditCardActivationResultView",
  components: { Button, Result },
  methods: {
    getIcon(path: string): string {
      return useAsset(path);
    },
  },
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const error = ref<boolean>();
    const title = ref<string>();
    const description = ref<string>();
    const btnText = ref<string>();
    const IFrameUrl = ref<string>();

    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search);
      error.value = !(urlParams.get("success") === "1");
      IFrameUrl.value = decodeURIComponent(urlParams.get("iframe") ?? "");
    });

    watch(error, (newValue) => {
      if (!newValue) {
        title.value = t("PAYJOY_CARD_VIEWS.ACTIVATION_RESULT_TITLE");
        description.value = t(
          "PAYJOY_CARD_VIEWS.ACTIVATION_RESULT_DESCRIPTION"
        );
        btnText.value = t("PAYJOY_CARD_VIEWS.ACTIVATION_RESULT_BTN");
      } else {
        title.value = t("PAYJOY_CARD_VIEWS.ACTIVATION_ERROR_TITLE");
        description.value = t("PAYJOY_CARD_VIEWS.ACTIVATION_ERROR_DESCRIPTION");
        btnText.value = t("PAYJOY_CARD_VIEWS.ACTIVATION_ERROR_BTN");
      }
    });

    const dismiss = () => {
      if (!error.value) {
        router.replace({ name: "CardIntroTutorialView" });
      } else {
        router.replace({ name: "CreditCardActivationView" });
      }
    };

    const openWhatsApp = () => {
      const helpMsg = t("CL_WP_HELP_MSG", {
        deviceTag: AuthenticationHelper.getDeviceTag(),
      });
      window.open("https://wa.me/+525575028669?text=" + helpMsg, "_system");
    };

    return {
      t,
      title,
      btnText,
      description,
      error,
      IFrameUrl,
      dismiss,
      openWhatsApp,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
#contact-support {
  color: $pj-color-green;
  text-align: center;
  font-family: Nunito;
  font-size: 16px;
  font-style: italic;
  font-weight: 600;
  line-height: 22.4px; /* 140% */
  letter-spacing: 0.24px;
}

.main {
  position: relative;
}

#iframe {
  position: absolute;
  bottom: 3rem;
  left: 1rem;
  right: 1rem;
}
</style>
